var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('p',{staticClass:"text-center",domProps:{"innerHTML":_vm._s(_vm.error)}},[_vm._v(" "+_vm._s(_vm.error)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }